export const ChartColors = {
  ADMITTED: '#00c981',
  NOT_ADMITTED: '#8ff9ff',
  ARABLE_AREA: '#00c981',
  CROP_AREA: '#01E6F5',
  TOTAL_AREA: '#FFF',
  RED: '#DF5353',
  GREEN: '#00FCA1',
  BLUE_LIGHT: '#01E6F5',
  PINK: '#FA14FF',
  BLUE: '#0008FC',
  WHITE: '#FCFCFC',
  OFF_WHITE: '#DADADA',
  LIGHT_GRAY: '#C4C4C4',
  GRAY: '#8F8F8F',
  YELLOW: '#FFE593',
  ORANGE: '#b8833f',
  BACKGROUND: '#12191c',
  GAUGE_RED: '#DF5353',
  GAUGE_YELLOW: '#DDDF0D',
  GAUGE_GREEN: '#55BF3B',
  LINE_HOVER: '#fdadff',

};

export const ChartConstants = {
  FONT_FAMILY: 'BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif',

  CREDITS_TEXT: 'powered by agronow',
  CREDITS_HREF: 'https://www.agronow.com.br',

  TITLE_STYLE: { fontSize: 15, fontWeight: 'normal' },
  TITLE_STYLE_BOLD: { fontSize: 16, fontWeight: 'bold' },

}
